


































import Vue from 'vue';
import { Button } from '@descomplica/vue-components';
import ProuniHeader from '@/components/prouni/ProuniHeader.vue';
import { getAssetPath } from '@/helpers/assets';
import prouniAuth from '@/helpers/prouniAuth';
import PROUNI_VIEWS_NAMES from '@/router/prouniViewsNames';

export default Vue.extend({
  name: 'ProuniNotEligible',
  components: { Button, ProuniHeader },
  data() {
    return {
      loggedEmail: prouniAuth.getPocketProfile()?.email || '',
      heroImageSrc: getAssetPath('img/prouni/hero-not-eligible.svg'),
    };
  },
  mounted() {
    // Direct hits without a session go back to the start screen (login).
    if (!prouniAuth.isLogged()) {
      this.$router.push({ name: PROUNI_VIEWS_NAMES.PROUNI_START }).catch(() => undefined);
    }
  },
  methods: {
    switchAccount() {
      prouniAuth.logout();
      // Full reload so the pocket iframe/session state is rebuilt from scratch.
      window.location.href = '/prouni';
    },
  },
});
